module.exports = {
    ComponentMixin: require('./mixins/ImmutableMixin'),
    createImmutableMixin: require('./lib/createImmutableMixin'),
    createImmutableContainer: require('./lib/createImmutableContainer'),
    createImmutableStore: require('./lib/createImmutableStore'),
    ImmutableStore: require('./lib/ImmutableStore')
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxible-immutable-utils/index.js
 ** module id = 304
 ** module chunks = 0
 **/